module.exports = __webpack_public_path__ + "static/media/ig.76de398f.svg";